"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectMetaObserver = void 0;
var custom_observer_1 = require("./custom-observer");
/**
 * A subclass of Vue's internal `Observer` class for entity meta objects, which uses model
 * metadata to manage condition change rather than property walking and rewriting
 */
var ObjectMetaObserver = /** @class */ (function (_super) {
    __extends(ObjectMetaObserver, _super);
    function ObjectMetaObserver(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        return _super.call(this, value, shallow, mock) || this;
    }
    ObjectMetaObserver.prototype.ensureObservable = function () {
        if (this._observable === true) {
            return;
        }
        this.value.conditions.changed.subscribe(this._onConditionsChanged.bind(this));
        this._observable = true;
    };
    ObjectMetaObserver.prototype._onConditionsChanged = function () {
        // Notify interested observers of the condition change in order to update dependants
        this.onPropertyChange("conditions", null);
    };
    return ObjectMetaObserver;
}(custom_observer_1.CustomObserver));
exports.ObjectMetaObserver = ObjectMetaObserver;
